import React from 'react'
import feature from '../modules/feature';
import hero from '../modules/hero';
import imageText from '../modules/imageText';
import logoCloud from '../modules/logoCloud';
import multicolumn from '../modules/multicolumn';
import imageTextCards from '../modules/imageTextCards';
import barkRules from '../modules/barkRules';
import membership from '../modules/membership';
import list from '../modules/list';
import faq from '../modules/faq';
import franchiseForm from '../modules/franchiseForm';
import contactForm from '../modules/contactForm';
import eventList from '../modules/eventList';
import videoHeader from '../modules/videoHeader';
import heroVideo from '../modules/heroVideo';
import imageTextCarousel from '../modules/imageTextCarousel';
import eventCalendar from '../modules/eventCalendar';
import threeGrid from '../modules/threeGrid';
import gridMulticolumn from '../modules/gridMulticolumn';
import teamGrid from '../modules/teamGrid';
import eventsMulticolumn from '../modules/eventsMulticolumn';
import headingText from '../modules/headingText';
import slideshow from '../modules/slideshow';
import eventSocialGrid from '../modules/eventSocialGrid';
import action from '../modules/action';
import locationsLoop from '../modules/locationsLoop';
import locationFinder from '../modules/locationFinder';
import jobListing from '../modules/jobListing';
import eventsAPI from '../modules/eventsAPI';

const PageBuilder = (props) => {
  const { type, pageBuilder, _rawPageBuilder } = props;
  const Components = {
    hero: hero,
    feature: feature,
    imageText: imageText,
    logoCloud: logoCloud,
    multicolumn: multicolumn,
    imageTextCards: imageTextCards,
    barkRules: barkRules,
    membership: membership,
    list: list,
    faq: faq,
    franchiseForm: franchiseForm,
    contactForm: contactForm,
    eventList: eventList,
    videoHeader: videoHeader,
    heroVideo: heroVideo,
    imageTextCarousel: imageTextCarousel,
    eventCalendar: eventCalendar,
    threeGrid: threeGrid,
    gridMulticolumn: gridMulticolumn,
    teamGrid: teamGrid,
    eventsMulticolumn: eventsMulticolumn,
    headingText: headingText,
    slideshow: slideshow,
    eventSocialGrid: eventSocialGrid,
    action: action,
    locationsLoop: locationsLoop,
    locationFinder: locationFinder,
    jobListing: jobListing,
    eventsAPI: eventsAPI
  }
  return pageBuilder.map((block, index) => {
    if (Components[block._type]) {
      return React.createElement(Components[block._type], {
        key: block._key,
        block: block,
        type,
        raw: _rawPageBuilder[index]
      })
    }
  })
}

export default PageBuilder
